import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Collapse from "react-bootstrap/Collapse";
import { getUserById } from "../../../services/UserService"; // <-- create this service if not exists

const ViewUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const hasFetched = useRef(false);

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      fetchUsers();
    }
  }, [id]);

  const fetchUsers = async (pageNumber = 1, query = "") => {
    try {
      setLoading(true);
      const response = await getUserById(id, pageNumber, limit, query);
      const { data, documents, pagination } = response.data;
      setUser(data);
      setUsers(documents || []);
      setTotalPages(pagination?.totalPages || 0);
      setTotalItems(pagination?.totalItems || 0);
      setPage(pagination?.currentPage || 1);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setPage(1);
    fetchUsers(1, searchTerm);
  };

  const handleReset = () => {
    setSearchTerm("");
    setPage(1);
    fetchUsers(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
      fetchUsers(newPage, searchTerm);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <>
        <PageTitle motherMenu="User" activeMenu="View User" />
        <div className="text-center p-5 text-danger">User not found</div>
      </>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu="View User"
        motherMenu="User"
        activeMenuLink={`view-user/${id}`}
        motherMenuLink={"user"}
      />
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div
              className="d-flex align-items-center gap-2 cursor-pointer"
              onClick={() => navigate("/user")}
            >
              <i className="fas fa-chevron-left"></i>
              <h4 className="mb-0">User List</h4>
            </div>
          </div>

          <div className="d-flex align-items-center mb-4">
            {user.profile ? (
              <img
                src={user.profile}
                alt="User Avatar"
                className="rounded-circle border border-black me-3"
                width={80}
                height={80}
              />
            ) : (
              <div
                className="rounded-circle bg-white border border-black d-flex align-items-center justify-content-center me-3"
                style={{ width: 80, height: 80 }}
              >
                <i className="fas fa-user text-black fs-3"></i>
              </div>
            )}
            <div>
              <h4 className="mb-1">{user.name || "Unnamed User"}</h4>
              <p className="mb-0 text-muted">{user.email}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Full Name</label>
              <p className="form-control-plaintext text-capitalize">
                {user.name || "-"}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Email</label>
              <p className="form-control-plaintext">{user.email || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Mobile</label>
              <p className="form-control-plaintext">{user.mobile || "-"}</p>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Place</label>
              <p className="form-control-plaintext text-capitalize">
                {user.place || "-"}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Joined At</label>
              <p className="form-control-plaintext">
                {user.createdAt
                  ? new Date(user.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                  : "-"}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Status</label>
              <p className="form-control-plaintext">
                <span
                  className={`badge d-inline-block text-capitalize ${user.status === "active"
                    ? "bg-success"
                    : user.status === "inactive"
                      ? "bg-secondary"
                      : "bg-warning"
                    }`}
                >
                  {user.status || "Unknown"}
                </span>
              </p>
            </div>
          </div>

          <hr />

          {users.length > 0 && (<div className="d-flex justify-content-between align-items-center mb-4">
            <div
              className="d-flex align-items-center gap-2"
            >
              <h4>User Documents</h4>
            </div>
          </div>)}

          {users.length == 0 ? (
            <>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div
                  className="d-flex align-items-center gap-2"
                >
                  <h4>User Documents not uploaded yet.</h4>
                </div>
              </div>
            </>
          ) : (
            <div className="row">
              <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                  <div className={`content-title`} onClick={() => setOpen(!open)}>
                    <div className="cpa">
                      <i className="fas fa-filter me-2"></i>Filter
                    </div>
                    <div className="tools">
                      <Link
                        to={"#"}
                        className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                      >
                        <i className="fas fa-angle-up"></i>
                      </Link>
                    </div>
                  </div>
                  <Collapse in={open}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-xl-3 col-sm-6">
                            <label className="form-label">Name</label>
                            <input
                              type="text"
                              className="form-control mb-3 mb-xl-0"
                              id="exampleFormControlInput1"
                              placeholder="Name"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                          <div className="col-xl-3 col-sm-6 align-self-end">
                            <button
                              className="btn btn-primary me-2 rounded-sm"
                              title="Click here to Search"
                              type="button"
                              onClick={handleSearch}
                            >
                              <i className="fa fa-search me-1"></i>Filter
                            </button>
                            <button
                              className="btn btn-danger light rounded-sm"
                              title="Click here to remove filter"
                              type="button"
                              onClick={handleReset}
                            >
                              <i className="fa fa-undo me-1"></i>
                              Remove Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
                <div className="filter cm-content-box box-primary">
                  <div className={`content-title`} onClick={() => setOpen2(!open2)}>
                    <div className="cpa">
                      <i className="fas fa-user me-1" />
                      User Documents
                    </div>
                    <div className="tools">
                      <Link
                        to={"#"}
                        className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      >
                        <i className="fas fa-angle-up"></i>
                      </Link>
                    </div>
                  </div>
                  <Collapse in={open2}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body py-3">
                        {loading ? (
                          <p>Loading...</p>
                        ) : (
                          <div className="table-responsive order-list-table">
                            <div
                              id="blog_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table className="table table-responsive-lg table-condensed flip-content">
                                <thead>
                                  <tr>
                                    <th className="text-black">S.No</th>
                                    <th className="text-black">Name</th>
                                    <th className="text-black">Type</th>
                                    <th className="text-black">Uploaded At</th>
                                    <th className="text-black text-end">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {users.length > 0 ? (
                                    users.map((item, ind) => (
                                      <tr key={ind}>
                                        <td>{(page - 1) * limit + ind + 1}</td>
                                        <td className="truncate">{item.original_name}</td>
                                        <td className="truncate">{item.document_type}</td>
                                        <td>
                                          {new Date(
                                            item.createdAt
                                          ).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          })}
                                        </td>
                                        <td className="text-end">
                                          <a
                                            href={item.file_path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary btn-sm content-icon me-1"
                                          >
                                            <i className="fa fa-eye"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="8" className="text-center">
                                        No users found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              {totalPages > 0 && (
                                <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                  <div className="dataTables_info">
                                    {totalItems > 0 && (
                                      <>
                                        Showing {(page - 1) * limit + 1} to{" "}
                                        {Math.min(page * limit, totalItems)} of{" "}
                                        {totalItems} entries
                                      </>
                                    )}
                                  </div>

                                  <div
                                    className="dataTables_paginate paging_simple_numbers"
                                    id="example2_paginate"
                                  >
                                    {/* Prev button */}
                                    <Link
                                      className={`paginate_button previous ${page === 1 ? "disabled" : ""
                                        }`}
                                      to="#"
                                      onClick={() =>
                                        page > 1 && handlePageChange(page - 1)
                                      }
                                    >
                                      <i className="fa fa-angle-double-left" />
                                    </Link>

                                    <span>
                                      {Array.from(
                                        { length: totalPages },
                                        (_, i) => i + 1
                                      )
                                        .filter((i) => {
                                          // Always show first 2 and last 2
                                          if (i <= 2 || i > totalPages - 2)
                                            return true;
                                          // Show nearby pages of the current one
                                          if (Math.abs(page - i) <= 1) return true;
                                          return false;
                                        })
                                        .reduce((acc, i, index, arr) => {
                                          // Add ellipsis between distant page numbers
                                          if (index > 0 && i - arr[index - 1] > 1)
                                            acc.push("ellipsis");
                                          acc.push(i);
                                          return acc;
                                        }, [])
                                        .map((item, index) =>
                                          item === "ellipsis" ? (
                                            <span
                                              key={index}
                                              className="paginate_button disabled"
                                            >
                                              ...
                                            </span>
                                          ) : (
                                            <Link
                                              key={index}
                                              to="#"
                                              className={`paginate_button ${page === item ? "current" : ""
                                                }`}
                                              onClick={(e) => {
    e.preventDefault();
    handlePageChange(item);
  }}
                                            >
                                              {item}
                                            </Link>
                                          )
                                        )}
                                    </span>

                                    {/* Next button */}
                                    <Link
                                      className={`paginate_button next ${page === totalPages ? "disabled" : ""
                                        }`}
                                      to="#"
                                      onClick={() =>
                                        page < totalPages &&
                                        handlePageChange(page + 1)
                                      }
                                    >
                                      <i className="fa fa-angle-double-right" />
                                    </Link>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div >
            </div >)}
        </div >
      </div >
    </>
  );
};

export default ViewUser;
